import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  px: 2,
  py: 1.5,
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const icon: SxStyle = {
  color: (p) => p.palette.grey[500],
};
